// Actions
import { onTypeOfContentChange } from "../../../redux/pages/merchandisesPage/merchandisesPageActions";

// Components
// Boxes
import MerchandiseDescriptionBox from "./merchandiseDescriptionBox";
// Dialogs
import AlertDialog from "../../dialogs/alertDialog";
// Menus
import MerchandiseDescriptionActionMenu from "../../menus/merchandisesPage/merchandiseDescriptionActionMenu";
// Modals
import ModalContainer from "../../modals/modalContainer";
import MerchandiseDescriptionActionModal from "../../modals/merchandisesPage/merchandiseDescriptionActionModal";

// Configs
import stylesConfig from "../../../configs/stylesConfig";

// Custom Hooks
import { useLanguage } from "../../../customHooks/getLanguage";

// Fetches
import {
  deleteMerchandiseDescriptionFetch,
  getAllMerchandiseDescriptionsByMerchandiseIdFetch,
} from "../../../fetches/merchandiseDescriptionFetches";

// Material UI
// Components
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
// Icons
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";

// React
import { useEffect, useState } from "react";

// React-Redux
import { useDispatch, useSelector } from "react-redux";

// Styles
import { useStandardItemBoxesContainerStyles } from "../../../styles/componentStyles/boxStyles/standardItemBoxesContainerStyles";

function MerchandiseDescriptionBoxesContainer() {
  // Hooks
  // Languages
  const t = useLanguage();
  // Redux
  const dispatch = useDispatch();
  // Styles
  const classes = useStandardItemBoxesContainerStyles();

  // Redux Store
  const merchandiseId = useSelector(
    (state) => state.merchandisesPage.merchandiseId
  );
  const formSubmitCount = useSelector(
    (state) => state.merchandisesPage.formSubmitCount
  );
  const token = useSelector((state) => state.staff.token);

  // States
  // Data
  const [merchandiseDescriptions, setMerchandiseDescriptions] = useState(null);
  // Dialog
  const [
    merchandiseDescriptionActionDialogText,
    setMerchandiseDescriptionActionDialogText,
  ] = useState("");
  const [
    merchandiseDescriptionActionDialogType,
    setMerchandiseDescriptionActionDialogType,
  ] = useState(null);
  const [
    showMerchandiseDescriptionActionDialog,
    setShowMerchandiseDescriptionActionDialog,
  ] = useState(false);
  // Hover
  const [currentItemId, setCurrentItemId] = useState(null);
  const [hoveredItemId, setHoveredItemId] = useState(null);
  // Menu
  const [
    showMerchandiseDescriptionActionMenu,
    setShowMerchandiseDescriptionActionMenu,
  ] = useState(null);
  // Modals
  const [
    showMerchandiseDescriptionActionModal,
    setShowMerchandiseDescriptionActionModal,
  ] = useState(false);

  // Handle States
  const itemsArr = merchandiseDescriptions;

  // Events
  // Events - Box
  const onItemClicked = (itemId) => {
    // Set States
    setCurrentItemId(itemId);
    displayMerchandiseDescriptionActionModal();
  };

  const onItemRightClicked = (itemId, currentTarget) => {
    // Set States
    setCurrentItemId(itemId);
    setShowMerchandiseDescriptionActionMenu(currentTarget);
  };

  const onItemShowMenuBtnClicked = (itemId, currentTarget) => {
    // Set States
    setCurrentItemId(itemId);
    setShowMerchandiseDescriptionActionMenu(currentTarget);
  };

  // Events - Dialogs
  const onMerchandiseDescriptionActionDialogCanceled = () => {
    // Set States
    setShowMerchandiseDescriptionActionDialog(false);
  };

  const onMerchandiseDescriptionActionDialogConfirmed = () => {
    switch (merchandiseDescriptionActionDialogType) {
      case "DeleteMerchandiseDescription":
        deleteMerchandiseDescription();
        break;
      default:
        break;
    }

    // Set States
    setShowMerchandiseDescriptionActionDialog(false);
  };

  // Events - Hover
  const onMouseEnterItem = (itemId) => {
    // Set States
    setHoveredItemId(itemId);
  };

  const onMouseLeaveItem = () => {
    // Set States
    setHoveredItemId(null);
  };

  // Events - Modal
  const onMerchandiseDescriptionActionModalClosed = () => {
    // Set States
    setShowMerchandiseDescriptionActionModal(false);

    getAllMerchandiseDescriptionsByMerchandiseId();
  };

  // Events - Title
  const onAddItemBtnClicked = () => {
    // Set States
    setCurrentItemId(null);
    displayMerchandiseDescriptionActionModal();
  };

  const onChangeTypeOfContentBtnClicked = () => {
    // Update Redux Store
    dispatch(onTypeOfContentChange("MerhandiseUnits"));
  };

  // Functions
  // Functions - Normal
  const displayMerchandiseDescriptionActionDialog = (
    merchandiseDescriptionActionType
  ) => {
    // Set States
    setMerchandiseDescriptionActionDialogType(merchandiseDescriptionActionType);

    switch (merchandiseDescriptionActionType) {
      case "DeleteMerchandiseDescription":
        setMerchandiseDescriptionActionDialogText(t("確認要刪除 描述 嗎？"));
        break;
      default:
        break;
    }

    // Set States
    setShowMerchandiseDescriptionActionDialog(true);
  };

  const displayMerchandiseDescriptionActionModal = () => {
    setShowMerchandiseDescriptionActionModal(true);
  };

  // Functions - Mutations
  const deleteMerchandiseDescription = async () => {
    const results = await deleteMerchandiseDescriptionFetch(
      token,
      currentItemId
    );

    if (results.success) {
      getAllMerchandiseDescriptionsByMerchandiseId();
    }
  };

  // Functions - Queries
  const getAllMerchandiseDescriptionsByMerchandiseId = async () => {
    const results = await getAllMerchandiseDescriptionsByMerchandiseIdFetch(
      token,
      merchandiseId
    );

    // Set States
    setMerchandiseDescriptions(
      results.merchandiseDescriptions ? results.merchandiseDescriptions : null
    );
  };

  // Life Cycle
  useEffect(() => {
    if (merchandiseId) {
      getAllMerchandiseDescriptionsByMerchandiseId();
    }
  }, [merchandiseId, formSubmitCount]);

  return (
    <div className={classes.contentBox}>
      {/* Dialog */}
      <AlertDialog
        // Events
        onDialogClosed={onMerchandiseDescriptionActionDialogCanceled}
        onDialogConfirmed={onMerchandiseDescriptionActionDialogConfirmed}
        // States
        dialogText={merchandiseDescriptionActionDialogText}
        showDialog={showMerchandiseDescriptionActionDialog}
      />
      {/* Menu */}
      <MerchandiseDescriptionActionMenu
        // States
        showMerchandiseDescriptionActionMenu={
          showMerchandiseDescriptionActionMenu
        }
        // Set States
        setShowMerchandiseDescriptionActionMenu={
          setShowMerchandiseDescriptionActionMenu
        }
        // Functions
        displayMerchandiseDescriptionActionDialog={
          displayMerchandiseDescriptionActionDialog
        }
        displayMerchandiseDescriptionActionModal={
          displayMerchandiseDescriptionActionModal
        }
      />
      {/* Modal */}
      <ModalContainer
        // Events
        onModalClosed={onMerchandiseDescriptionActionModalClosed}
        // States
        showModal={showMerchandiseDescriptionActionModal}
      >
        <MerchandiseDescriptionActionModal
          // Events
          onModalClosed={onMerchandiseDescriptionActionModalClosed}
          // States
          merchandiseDescriptionId={currentItemId}
        />
      </ModalContainer>
      {/* Title */}
      <div className={classes.titleContainer}>
        <div className={classes.titleTextContainer}>
          <Typography variant="h6" align={"left"}>
            {t("描述s")}
          </Typography>
          <Tooltip placement="right" title={t("新增描述")}>
            <IconButton color={"primary"} onClick={onAddItemBtnClicked}>
              <AddRoundedIcon />
            </IconButton>
          </Tooltip>
        </div>
        <Button
          endIcon={<ChevronRightRoundedIcon />}
          onClick={onChangeTypeOfContentBtnClicked}
          variant="text"
        >
          {t("顯示計算單位")}
        </Button>
      </div>
      {/* List */}
      {itemsArr ? (
        itemsArr.map((item) => (
          <MerchandiseDescriptionBox
            key={item.id}
            // States
            hoveredItemId={hoveredItemId}
            item={item}
            // Events
            onItemClicked={onItemClicked}
            onItemRightClicked={onItemRightClicked}
            onItemShowMenuBtnClicked={onItemShowMenuBtnClicked}
            onMouseEnterItem={onMouseEnterItem}
            onMouseLeaveItem={onMouseLeaveItem}
          />
        ))
      ) : (
        <div className={classes.emptyDataContainer}>
          <Typography align={"center"} color={stylesConfig.greyTextColor}>
            {t("未有描述資料")}
          </Typography>
        </div>
      )}
    </div>
  );
}

export default MerchandiseDescriptionBoxesContainer;
